import { Appear } from "@components/motion/Appear"
import { getTranslation } from "@utils/Translations"
import { defineBlock, EditableText, InnerBlocks, SingleContentBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "FAQ",
  tags: ["#page"],
}

export default defineBlock("section/faq", (props) => {
  return (
    <Appear className="faq w-full my-9 md:px-6">
      <div className="w-full bg-[#f3f3f3] pt-10 pb-8 rounded-lg">
        <div className="max-w-blogPostVideoW block-padding mx-auto flex flex-col gap-6">
          <EditableText
            store="title"
            as="h2"
            plainText
            defaultValue={getTranslation("frequentlyAskedQuestions", "Frequently Asked Questions")}
            className="type-header-l text-charcoal"
          />
          <div className="w-full flex flex-col">
            <InnerBlocks
              allowedBlocks={["section/faq-item"]}
              template={[
                ["section/faq-item", {}],
                ["section/faq-item", {}],
                ["section/faq-item", {}],
              ]}
              orientation="vertical"
            />
          </div>
        </div>
      </div>
    </Appear>
  )
})
